import React, { useState, useEffect } from 'react';
import { CModal, CModalHeader, CModalBody, CModalTitle, CButton } from '@coreui/react';
import { useNavigate } from 'react-router-dom';
import { BsArrowRight } from 'react-icons/bs';
import axios from 'axios';
import '../../../assets/css/mainstyle.css';
import api from '../../../service/caller'; // Axios instance configurée
import { getUserIdFromToken } from '../../../utils/authUtils';
import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/style.css';


const EditPatientModal = ({ visibleEdit, onClose, patientSelected, onPatientEdit }) => {

    const formatDate = (date) => {
        const d = new Date(date);
        const year = d.getFullYear();
        const month = String(d.getMonth() + 1).padStart(2, '0'); // Mois de 01 à 12
        const day = String(d.getDate()).padStart(2, '0'); // Jour de 01 à 31
        return `${year}-${month}-${day}`;
    };

    const [hospitals, setHospitals] = useState([]);
    const [message, setMessage] = useState('');
    const [messageType, setMessageType] = useState('');
    const [formDataEdit, setFormDataEdit] = useState({});

    useEffect(() => {
        if (visibleEdit && patientSelected) {
            setFormDataEdit({
                patientNPI: patientSelected?.patientNPI || '',
                firstname: patientSelected?.firstname || '',
                lastname: patientSelected?.lastname || '',
                age: patientSelected?.age ? formatDate(patientSelected.age) : '',
                gender: patientSelected?.gender || '',
                phone: patientSelected?.phone || '',
                email: patientSelected?.email || '',
                hospitalId: patientSelected?.hospitalId?._id || '',
                address: patientSelected?.address || '',
                otherdetails: patientSelected?.otherdetails || '',
            });
        }
    }, [visibleEdit, patientSelected]);


    const navigate = useNavigate();  // Utilisation de useNavigate

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormDataEdit({ ...formDataEdit, [name]: value });
    };

    const handlePhoneChange = (phone) => {
        setFormDataEdit((prevData) => ({
            ...prevData,
            phone,
        }));
    };


    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            const response = await api.put(`/clinic/updatepatients/${patientSelected?._id}`, formDataEdit);
            setMessage('Patient updated avec succès!');
            setMessageType('success');
            const patientId = response.data.patient._id;  // Accéder à l'ID à partir de `patient`

            if (patientId) {
                // Rediriger vers la carte du patient avec l'ID
                navigate(`/patientcard/${patientId}`);
            }

            setFormDataEdit({
                patientNPI: '',
                firstname: '',
                lastname: '',
                age: '',
                gender: '',
                phone: '',
                email: '',
                hospitalId: '',
                address: '',
                otherdetails: ''
            });
        } catch (error) {
            console.error('Erreur lors de l’ajout du patient:', error);
            setMessage('Une erreur est survenue lors de l’ajout du patient.');
            setMessageType('error');
        }
    };

    const userId = getUserIdFromToken(); // Récupérer l'ID de l'utilisateur à partir du token

    // Fonction pour récupérer la liste des hôpitaux pour l'administrateur
    useEffect(() => {
        const fetchHospitals = async () => {
            if (!userId) {
                setMessage('Utilisateur non authentifié.');
                return;
            }
            try {
                const token = localStorage.getItem('access_token');
                const response = await api.get(`/api/hospitals/admin/` + token, {
                    headers: {
                        'Authorization': `Bearer ${localStorage.getItem('access_token')}`
                    }
                });
                setHospitals(response.data); // Sauvegarder les hôpitaux dans l'état
            } catch (error) {
                console.error('Erreur lors de la récupération des hôpitaux:', error);
                setMessage('Erreur lors de la récupération des hôpitaux.');
            }
        };
        if (userId) {
            fetchHospitals(); // Appeler la fonction pour récupérer les hôpitaux uniquement si l'utilisateur est authentifié
        }
    }, [userId]); // Dépendance sur userId pour recharger si nécessaire

    return (
        <CModal className='newregistermodal'
            alignment="center"
            scrollable
            size='lg'
            visible={visibleEdit}
            patientSelected={patientSelected}
            onClose={onClose}
            aria-labelledby="VerticallyCenteredScrollableExample2">
            <CModalHeader>
                <CModalTitle>Update patient {patientSelected?.firstname}</CModalTitle>
            </CModalHeader>
            <CModalBody className='p-5'>
                {message && (
                    <div className={`alert ${messageType === 'success' ? 'alert-success' : 'alert-danger'}`}>
                        {message}
                    </div>
                )}
                <form onSubmit={handleSubmit}>
                    <div className="form-group">
                        <label htmlFor="patientNPI">NPI</label>
                        <input
                            type="Number"
                            name="patientNPI"
                            id="patientNPI"
                            value={formDataEdit.patientNPI}
                            onChange={handleChange}
                            placeholder="0598677474333"
                            required
                        />
                    </div>
                    <div className="form-row row">
                        <div className="form-group col-md-6">
                            <label htmlFor="firstname">Firstname</label>
                            <input
                                type="text"
                                name="firstname"
                                id="firstname"
                                value={formDataEdit.firstname}
                                onChange={handleChange}
                                placeholder="Casos"
                                required
                            />
                        </div>
                        <div className="form-group col-md-6">
                            <label htmlFor="lastname">Lastname</label>
                            <input
                                type="text"
                                name="lastname"
                                id="lastname"
                                value={formDataEdit.lastname}
                                onChange={handleChange}
                                placeholder="Billal"
                                required
                            />
                        </div>
                    </div>
                    <div className="form-row row">
                        <div className="form-group col-md-4">
                            <label htmlFor="gender">Gender</label>
                            <select name="gender" id="gender" value={formDataEdit.gender} onChange={handleChange} required>
                                <option value="">Select Gender</option>
                                <option value="male">Male</option>
                                <option value="female">Female</option>
                                <option value="other">Other</option>
                            </select>
                        </div>

                        <div className="form-group col-md-4">
                            <label htmlFor="age">Date of birth</label>
                            <input
                                type="date"
                                name="age"
                                id="age"
                                value={formDataEdit.age} onChange={handleChange} required
                                placeholder="20-12-2000"
                            />
                        </div>
                        <div className="form-group col-md-4">
                            <label htmlFor="hospitalId">Hospital</label>
                            <select name="hospitalId" id="hospitalId" value={formDataEdit.hospitalId} onChange={handleChange} required>
                                <option value="">Select Hospital</option>
                                {hospitals.map((hospital) => (
                                    <option key={hospital._id} value={hospital._id}>
                                        {hospital.hospital_name} {/* Assurez-vous que votre modèle contient un champ 'name' */}
                                    </option>
                                ))}
                            </select>
                        </div>
                    </div>

                    <div className="form-row row telside">
                        <div className="form-group col-md-6">
                            <PhoneInput
                                country={'bj'}
                                value={formDataEdit.phone} // Liaison avec l'état formData.phone
                                onChange={handlePhoneChange} // Mise à jour de l'état lors de la modification
                                placeholder="Téléphone"
                                name="phone"
                                inputClass="w-100"
                            />
                        </div>

                        <div className="form-group col-md-6">
                            <label htmlFor="email">Email</label>
                            <input
                                type="email"
                                name="email"
                                onChange={handleChange} value={formDataEdit.email}
                                id="email"
                                placeholder="exemple@gmail.com"
                            />
                        </div>
                    </div>

                    <div className="form-group">
                        <label htmlFor="address">Address</label>
                        <input
                            name="address"
                            id="address" value={formDataEdit.address}
                            onChange={handleChange}
                            placeholder="Your address here"
                        />
                    </div>

                    <div className="form-group">
                        <label htmlFor="otherdetails">Details</label>
                        <input
                            name="otherdetails"
                            id="otherdetails" onChange={handleChange} value={formDataEdit.otherdetails}
                            placeholder="Your Details here"
                        />
                    </div>

                    <div className="savenewuser form-group d-flex justify-content-center">
                        <CButton type="submit">
                            Continue &nbsp; <BsArrowRight />
                        </CButton>
                    </div>
                </form>
            </CModalBody>
        </CModal>
    );
};

export default EditPatientModal;
